import { useSelector } from 'react-redux'

import { getAccountTypeAndLevel } from 'store/currentUser/selectors'

import { AccountType } from 'routes/routes'

const ACCOUNT_TYPE_PREFIX = {
  RetailAccount: 'RETAIL',
  BrandAccount: 'BRAND',
} as const

function accountTypeRouteWrapper(
  WrappedComponent: () => JSX.Element,
  { accountTypes }: { accountTypes: AccountType[] },
) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [type, level] = useSelector(getAccountTypeAndLevel) as [
    type: 'RetailAccount' | 'BrandAccount',
    level: 'Lite' | 'Pro',
  ]

  const currentAccountType =
    `${ACCOUNT_TYPE_PREFIX[type]}_${level.toUpperCase()}` as AccountType

  if (accountTypes.includes(currentAccountType)) {
    return <WrappedComponent />
  }

  return null
}

export default accountTypeRouteWrapper
